import moment from "moment";
import {getCartItemShippingCost} from "./deliveryFunctions";

export const SHIPPING_TIMES = {
  "Overnight": {
    min: 0,
    max: 0,
  },
  "1 day": {
    min: 1,
    max: 1,
  },
  "1-2 days": {
    min: 1,
    max: 2,
  },
  "1-3 day": {
    min: 1,
    max: 3,
  },
  "2-3 days": {
    min: 2,
    max: 3,
  },
  "3-5 days": {
    min: 3,
    max: 5,
  },
  "5-7 days": {
    min: 5,
    max: 7,
  },
  "1-2 weeks": {
    min: 7,
    max: 14,
  },
  "2-3 weeks": {
    min: 14,
    max: 21,
  },
  "2-4 weeks": {
    min: 14,
    max: 28,
  },
  "3-5 weeks": {
    min: 21,
    max: 35,
  },
  "4-6 weeks": {
    min: 28,
    max: 42,
  },
  "5-7 weeks": {
    min: 35,
    max: 49,
  },
  "6-8 weeks": {
    min: 42,
    max: 56,
  },
  "8-12 weeks": {
    min: 56,
    max: 84,
  },
  "FedEx Ground": {
    min: 0,
    max: 2,
  },
  "FedEx 2 Day": {
    min: 0,
    max: 4,
  },
  "FedEx Standard Overnight": {
    min: 0,
    max: 1,
  },
}

for (let i = 1; i < 10; i++) {
  SHIPPING_TIMES[i + " Days"] = {
    min: i,
    max: i,
  }
}

/**
 * @param cartItems {[cartItemInterface]}
 * @returns {object}
 */
export const getMinAndMaxDays = (cartItems) => {

  let minDays = null;
  let maxDays = null;

  cartItems.some(cartItem => {
    const shippingTime = getCartItemShippingCost(cartItem, "shippingTime");
    if (shippingTime && SHIPPING_TIMES[shippingTime]) {
      minDays = SHIPPING_TIMES[shippingTime].min;
      maxDays = SHIPPING_TIMES[shippingTime].max;
      return true
    }
    return false
  });

  cartItems.forEach(cartItem => {
    const shippingTime = getCartItemShippingCost(cartItem, "shippingTime");
    if (!shippingTime) {
      return
    }
    if (!SHIPPING_TIMES[shippingTime]) {
      const days = +((shippingTime || "").split(" Days")[0]);
      if (Number.isInteger(days)) {
        SHIPPING_TIMES[shippingTime] = {
          min: days,
          max: days,
        }
      }
    }
    if (SHIPPING_TIMES[shippingTime]) {
      if (SHIPPING_TIMES[shippingTime].min < minDays) {
        minDays = SHIPPING_TIMES[shippingTime].min
      }
      if (SHIPPING_TIMES[shippingTime].max > maxDays) {
        maxDays = SHIPPING_TIMES[shippingTime].max
      }
    }
  });

  let fromToString = "";

  if ((!Number.isInteger(minDays) || !Number.isInteger(maxDays)) && cartItems[0]) {
    fromToString = cartItems[0].shippingTime // return as is!
  } else if (minDays === maxDays) {
    fromToString = moment().add(minDays, 'days').format('MMMM Do YYYY')
  } else {
    fromToString = `${moment().add(minDays, 'days').format('MMMM Do YYYY')} - ${moment().add(maxDays, 'days').format('MMMM Do YYYY')}`
  }

  return {minDays, maxDays, fromToString}
}
